export enum ChartDivId {
  DEATH_NEED = "AkaAdviceChartDeathNeed",
  DEATH_SELECTED = "AkaAdviceChartDeathSelected",
  DISABILITY_MONTHLY = "AkaAdviceChartDisabilityMonthly",
  DISABILITY_YEARLY = "AkaAdviceChartDisabilityYearly",
  CRITICAL_ILLNESS = "AkaAdviceChartCriticalIllness",
}

export interface ChartSize {
  width: number;
  height: number;
}

export interface Coordinate {
  start: number;
  end: number;
}
